module.exports = "<template>\n\n    <h1>Buchungsmaske</h1>\n    <div id=\"sio-toma-mask\"></div>\n\n</template>\n";